import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SimpleTableValueDto } from '../SimpleTableDto';

@Component({
  selector: 'tags-strip-renderer',
  template: `
    <shared-tags-strip-component
      [tags]="tags">
    </shared-tags-strip-component>
  `
})
export class SharedTagsStripRendererAGGridComponent implements ICellRendererAngularComp {

  tags: any;

  agInit(params: any): void {
    const value: SimpleTableValueDto = params.value;

    if (!value) return;

    // segons com vinguin les dades
    this.tags = value.valueHTags;
  }

  refresh(): boolean {
    return false;
  }
}
